import {
  ActivityLiteModel,
  ActivityModel,
  getActivitiesKey,
  getActivityKey,
  useGetActivities,
  useGetActivity,
} from 'api-hooks/activity';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import React from 'react';

import { ColumnDataType } from '../type';

export function activityTransformer(
  item: ActivityLiteModel | ActivityModel,
): Option {
  return {
    id: item.id,
    label: [item.code, item.name].join(' - '),
    extra: item,
  };
}

export default function useActivityColumn() {
  const permission = useGetCrudPermission('activities');
  const { navigate } = useNavigation();

  const activityColumn = {
    dataType: ColumnDataType.select,
    useListQueryHook: useGetActivities,
    useDetailLazyQueryHook: useGetActivity,
    listKeyFunction: getActivitiesKey,
    detailKeyFunction: getActivityKey,
    getMemoizedListVariables: (page, q) => ({
      params: {
        q,
        page,
      },
    }),
    getMemoizedDetailVariables: (value: string) => ({
      id: value,
    }),
    listTransformer: (result) => {
      return result.data.map((v) => {
        const data = ModelTransformer(v, ActivityLiteModel);
        return activityTransformer(data);
      });
    },
    detailTransformer: (result) => {
      const data = ModelTransformer(result.data, ActivityModel);
      return activityTransformer(data);
    },
    paginationTransformer: (result) => {
      return result.meta;
    },
    renderCreate: permission.create,
    onClickCreate: React.useCallback(() => {
      navigate(NavigationRoutes.ActivitiesCreate);
    }, [navigate]),
  };

  return activityColumn;
}
